import Header from 'components/VerticalLayout/Header'
import React, { useState } from 'react'
import bgImage from "../../../assets/images/bgImage1.jpg";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Button, Card, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import useListProductPricing from './Hooks/useListProductPricing';
import AddEditPriceForm from './Components/AddEditPriceForm';
import useListOrg from '../useListOrg';

const ProductPricingPage = () => {

  const{isPending: orgsPending,data: orgData} = useListOrg(1,100)
  const orgs = orgData?.results || []
  // orgs
  // const orggs = JSON.parse(localStorage.getItem('appInitData'))
  // const orgs = orggs.organization
  
  // pagination
  const[currentPage,setCurrentPage]=useState(1);
  const pageSize = 10;
  // search
  const[searchTerm,setSearchTerm]=useState('');
  // custom hook for getting product price list
  const{isPending,isSuccess,isError,error,data}=useListProductPricing(currentPage,pageSize,searchTerm,{enabled:orgs.length>0});

  const prices = data?.results || [];
  const totalCount = data?.count || 0;
  const totalPages = Math.ceil(totalCount/pageSize);

  console.log(prices)
  // accordian open and close
  const [open, setOpen] = useState('');

  const toggle = (id) => {
    if (open === id) {
      setOpen('');
    } else {
      setOpen(id);
    }
  };
  
  // for modal
  const[isOpen,setIsOpen]=useState(false);
  // state to track whether its add or edit
  const[isEditMode,setIsEditMode]=useState(false);
  // stores price data for editing
  const[selectedPrice,setSelectedPrice]=useState(null);

  const AddModal=(org)=>{
    setIsEditMode(false)
    setSelectedPrice({org:org.org_id})
    setIsOpen(true)
  }

  const EditModal=(price)=>{
    setIsEditMode(true)
    setSelectedPrice(price)
    setIsOpen(true)
  }

  const closeModal=()=>{
    setIsEditMode(false)
    setSelectedPrice(null)
    setIsOpen(false)
  }

  return (
    <div className='account'>
      <Header/>
      <div className='accountbg'
          style={{
                background: `url(${bgImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundAttachment:"fixed",
                paddingTop:"80px",
                minHeight:"100vh",
                overflowY:"hidden",
                paddingLeft:"8px"
                }}
      >
      <Card className='p-4' style={{ maxHeight: "80vh", display: "flex", flexDirection: "column" }}>
        <div className="pb-2 mb-0">
          <h5 className="fw-bold">Product Price</h5>
          <p className='text-muted mb-0' style={{fontSize:'0.7rem'}}>Product Pricing per client</p>
        </div>
        
        <div style={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
          {
            orgsPending ? (
              <div className="d-flex justify-content-center align-items-center py-5">
                <Spinner color="primary" />
              </div>
            ) : (
              <Accordion flush open={open} toggle={toggle}>
          {orgs.map((org) => (
            <AccordionItem key={org.org_id}>
              <AccordionHeader targetId={org.org_id}>
                {org.name}
              </AccordionHeader>

              <AccordionBody accordionId={org.org_id}>
                {/* add price button */}
                <div className='py-2'>
                  <Button onClick={()=>AddModal(org)} className='btn py-2' style={{ backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder" }}
                  >
                    Add Price
                  </Button>
                </div>
                {prices.filter((price)=>price.org === org.org_id).map((price) => (
                  <div
                    key={price.id}
                    className="d-flex justify-content-between align-items-center border rounded p-2 mb-2"
                  >
                    <div>
                      <h6 className="mb-1">{price.products.product_name.startsWith("DA") ?
                        price.products.product_name.replace("DA","Desktop Appraisal") : price.products.product_name
                      }</h6>
                      <small>${price.price}</small>
                    </div>

                    <Button
                      style={{backgroundColor: "#00ADF0", color: "white",fontWeight: "bolder" }}
                      size="sm"
                      outline
                      onClick={() => EditModal(price)}
                    >
                      Edit
                    </Button>
                  </div>
                ))}
              </AccordionBody>
            </AccordionItem>
          ))}
        </Accordion>
            )
          }
          
        </div>
        
        {/* modal */}
        <Modal isOpen={isOpen} size='xl' backdrop='static' keyboard={false} toggle={null} fullscreen="xl" fade scrollable centered={true}>
          <ModalHeader close={<button type="button" className="btn-close" onClick={closeModal}/>}>
            Price Details
          </ModalHeader>
          <ModalBody>
            <AddEditPriceForm isEditMode={isEditMode} priceData={selectedPrice} onClose={closeModal}/>
          </ModalBody>
        </Modal>
      </Card>
      </div>
    </div>
  )
}

export default ProductPricingPage
